module.exports = new __parcel__URL__("map.d526d3ce.svg").toString();